<template>
  <div class="features-filter flex flex-col" :class="{ open: filterOpen }">
    <div class="category-selected mb-2">
      <div></div>
      <span class="font-bold text-lg pl-8">
        {{ (filter.category.name && filter.category.name[lang]) || 'All' }}
      </span>
      <button class="clickable" @click="$emit('close-filter')">
        <img loading="lazy" src="/img/icons/close-black.svg" alt="close-black" />
      </button>
    </div>
    <div v-for="(attr, index) in sortedFeaturesFilter" :key="index" class="feature">
      <div
        @click="toggleOption(attr.slug)"
        class="flex justify-between w-full h-full items-center border-b border-light-grey xmd:h-12"
      >
        <span class="font-bold text-base cursor-default normal-case">{{ attr.name }}</span>
        <img
          src="/img/icons/arrow-filtre-black.svg"
          alt="arrow-right"
          class="w-[7px] rotative-arrow"
          :class="{ open: isOptionOpen(attr.slug) }"
        />
      </div>
      <div class="openable-options" :class="{ open: isOptionOpen(attr.slug) }">
        <div class="category-selected mb-4">
          <button @click="closeOption(attr.slug)" class="clickable">
            <img loading="lazy" src="/img/icons/arrow-back-filtre.svg" alt="arrow-back" />
          </button>
          <span class="font-bold text-lg pr-8">
            {{ attr.name }}
          </span>
          <div></div>
        </div>
        <div class="scrollable-section">
          <div class="openable-options__option" v-if="attr.slug === 'type'">
            <div class="flex items-center">
              <input
              type="radio"
              :id="`radio-all`"
              :value="null"
              v-model="typesFilterSelected"
              :name="attr.slug"
              class="input-checkbox-radio"
              />
              <label class="line-clamp ml-2 text-sm" :for="`radio-all`"> {{ trans.choice("product.all", 1) }} </label>
            </div>
          </div>
          <div class="openable-options__option" v-for="(property, index) in attr.properties" :key="property.id">
            <div class="flex items-center" v-if="attr.slug === 'type'">
              <input
                type="radio"
                :id="`radio-${attr.slug}-${index}`"
                :value="{ id: property.id, cat: attr.slug, name: property.name}"
                v-model="typesFilterSelected"
                :name="attr.slug"
                class="input-checkbox-radio"
              />
              <label class="line-clamp ml-2 text-sm" :for="`radio-${attr.slug}-${index}`"> {{ property.name }}</label>
            </div>
            <div class="flex items-center" v-else>
              <input
                type="checkbox"
                :id="`check-${attr.slug}-${index}`"
                :value="{ id: property.id, cat: attr.slug, name: property.name}"
                v-model="featuresFilterSelected"
                 class="input-checkbox"
              />
              <label class="line-clamp ml-2 text-sm" :for="`check-${attr.slug}-${index}`"> {{ property.name }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="floating-buttons">
      <button class="btn btn-secondary" @click="cancelFilter">{{ trans.get('our-seeds.cancel') }}</button>
      <button class="btn btn-primary" @click="closeFilter">{{ trans.get('our-seeds.see-results') }}</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import {
  GET_FEATURES_FILTER,
  GET_FILTER,
  GET_FEATURES_FILTER_SELECTED,
  RETREIVE_FEATURES_FILTER_ACTION,
  SET_FEATURES_FILTER_SELECTED,
  GET_TYPES_FILTER_SELECTED,
  SET_TYPES_FILTER_SELECTED,
  CLEAR_FILTERS_ACTION
} from '../../store/shop/types'
import mixin from '../../mixin'

export default {
  props: {
    filterOpen: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [mixin],
  data: () => {
    return {
      optionOpened: {},
    }
  },
  computed: {
    ...mapGetters({
      featuresFilter: GET_FEATURES_FILTER,
      filter: GET_FILTER,
    }),
    featuresFilterSelected: {
      get() {
        return this.$store.getters[GET_FEATURES_FILTER_SELECTED]
      },
      set(value) {
        this.setFeaturesFilterSelected(value)
      },
    },
    typesFilterSelected: {
      get() {
        return this.$store.getters[GET_TYPES_FILTER_SELECTED]
      },
      set(value) {
        this.setTypesFilterSelected(value)
      },
    },
    sortedFeaturesFilter() {
      // Apply ordering only for flavor_taste and effect
      const filtersToOrder = ['flavor_taste', 'effect'];

      return this.featuresFilter.map(attr => {
        if (filtersToOrder.includes(attr.slug)) {
          return {
            ...attr,
            properties: attr.properties.slice().sort((a, b) => a.name.localeCompare(b.name))
          };
        }
        return attr;
      });
    },
  },
  methods: {
    toggleOption(payload) {
      this.optionOpened.hasOwnProperty([payload])
        ? (this.optionOpened = {
            ...this.optionOpened,
            [payload]: !this.optionOpened[payload],
          })
        : (this.optionOpened = {
            ...this.optionOpened,
            [payload]: true,
          })
    },
    closeOption(payload) {
      this.optionOpened = {
        ...this.optionOpened,
        [payload]: false,
      }
    },
    isOptionOpen(payload) {
      return this.optionOpened.hasOwnProperty([payload]) ? this.optionOpened[payload] : false
    },
    closeFilter() {
      this.optionOpened = {}
      this.$emit('close-filter')
    },
    cancelFilter() {
      this.clearFilters();
      setTimeout(() => {
        this.closeFilter()
      }, 500)
    },
    ...mapMutations({
      setFeaturesFilterSelected: SET_FEATURES_FILTER_SELECTED,
      setTypesFilterSelected: SET_TYPES_FILTER_SELECTED
    }),
    ...mapActions({
      retreiveFeaturesFilter: RETREIVE_FEATURES_FILTER_ACTION,
      clearFilters: CLEAR_FILTERS_ACTION
    }),
  },
  created() {
    this.retreiveFeaturesFilter()
  },
}
</script>
<style lang="scss" scoped>
  .features-filter {
  min-height: 300px;
  transition: opacity 0.3s ease-in-out;
  margin-right: auto;
}
</style>
